module.exports = __webpack_public_path__ + "static/media/2.059dbb6d.png";